module.exports = {
          srcSet: __webpack_public_path__ + "e4e764a0.jpg"+" 330w",
          images:[ {path: __webpack_public_path__ + "e4e764a0.jpg",width: 330,height: 200}],
          src: __webpack_public_path__ + "e4e764a0.jpg",
          toString:function(){return __webpack_public_path__ + "e4e764a0.jpg"},
          
          width: 330,
          height: 200
        }